import { render, staticRenderFns } from "./StoredProcedureIntegration.vue?vue&type=template&id=ecbfd864&"
import script from "./StoredProcedureIntegration.vue?vue&type=script&lang=js&"
export * from "./StoredProcedureIntegration.vue?vue&type=script&lang=js&"
import style0 from "./StoredProcedureIntegration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports